import React from "react";
import { Link } from "react-router-dom";
import LegalAuthFooter from "../Legal/LegalAuthFooter";
import PasswordInput from "./PasswordInput";
import { getPasswordRules } from "../../utils/passwordPolicy";

const PASSWORD_RULES = getPasswordRules();

const FormRegister = ({ handleSubmit, handleChange, loading, error }) => {
    return (
        <div className="tamcare-auth-card tamcare-auth-card--register">
            <div className="tamcare-auth-card__header tamcare-auth-card__header--center">
                <h2>Đăng Ký Tài Khoản</h2>
                <p>Cùng chúng tôi bảo vệ sức khỏe cho người thân</p>
            </div>

            <form className="tamcare-auth-form" onSubmit={handleSubmit} method="POST">
                <div className="tamcare-role-title">Bạn là ai?</div>
                <div className="tamcare-role-selection">
                    <div className="tamcare-role-option">
                        <input type="radio" id="role_elderly" name="role" value="elderly" defaultChecked onChange={handleChange} />
                        <label htmlFor="role_elderly" className="tamcare-role-label">
                            <i className="fa-solid fa-person-cane"></i>
                            <span className="tamcare-role-label__title">Người Cao Tuổi</span>
                            <span className="tamcare-role-label__sub">Chữ to, dễ thao tác</span>
                        </label>
                    </div>

                    <div className="tamcare-role-option">
                        <input type="radio" id="role_relative" name="role" value="relative" onChange={handleChange} />
                        <label htmlFor="role_relative" className="tamcare-role-label">
                            <i className="fa-solid fa-user-nurse"></i>
                            <span className="tamcare-role-label__title">Người Chăm Sóc</span>
                            <span className="tamcare-role-label__sub">Quản lý & Theo dõi</span>
                        </label>
                    </div>
                </div>

                <div className="tamcare-grid-2">
                    <div className="form-group">
                        <label htmlFor="username">Tên đăng nhập</label>
                        <div className="tamcare-input-wrap">
                            <i className="fa-solid fa-user"></i>
                            <input
                                id="username"
                                type="text"
                                name="username"
                                placeholder="ong_nguyen_van_a"
                                required
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="fullName">Họ và tên</label>
                        <div className="tamcare-input-wrap">
                            <i className="fa-regular fa-user"></i>
                            <input
                                id="fullName"
                                type="text"
                                name="fullName"
                                placeholder="Nguyễn Văn A"
                                required
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="tamcare-grid-2">
                    <div className="form-group">
                        <label htmlFor="phone">Số điện thoại (tùy chọn)</label>
                        <div className="tamcare-input-wrap">
                            <i className="fa-solid fa-phone"></i>
                            <input
                                id="phone"
                                type="text"
                                name="phone"
                                placeholder="09xx xxx xxx"
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email liên hệ</label>
                        <div className="tamcare-input-wrap">
                            <i className="fa-regular fa-envelope"></i>
                            <input
                                id="email"
                                type="email"
                                name="email"
                                placeholder="email@vi-du.com"
                                required
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="tamcare-grid-2">
                    <div className="form-group">
                        <label htmlFor="password">Mật khẩu</label>
                        <PasswordInput
                            id="password"
                            name="password"
                            required
                            minLength={8}
                            autoComplete="new-password"
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword">Nhập lại mật khẩu</label>
                        <PasswordInput
                            id="confirmPassword"
                            name="confirmPassword"
                            required
                            minLength={8}
                            autoComplete="new-password"
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <ul className="tamcare-password-rules">
                    {PASSWORD_RULES.map((rule) => (
                        <li key={rule}>{rule}</li>
                    ))}
                </ul>
                <label className="tamcare-auth-legal" style={{ display: 'flex', alignItems: 'flex-start', gap: 8, textAlign: 'left', marginBottom: 16 }}>
                    <input type="checkbox" name="agreeTerms" value="1" required style={{ marginTop: 4 }} />
                    <span>
                        Tôi đồng ý với{' '}
                        <Link to="/terms" target="_blank" rel="noreferrer">Điều khoản sử dụng</Link>
                        {' '}và{' '}
                        <Link to="/privacy" target="_blank" rel="noreferrer">Chính sách bảo mật</Link>.
                    </span>
                </label>

                {error && (
                    <div className="tamcare-auth-error" style={{ marginBottom: 16, color: '#ef4444', fontWeight: 600 }}>
                        {error}
                    </div>
                )}

                <button type="submit" className="tamcare-auth-btn" disabled={loading}>
                    {loading ? "Đang xử lý..." : "Tham Gia TamCare Ngay"}
                    <i className="fa-solid fa-heart-pulse"></i>
                </button>
            </form>

            <div className="tamcare-auth-footer tamcare-auth-footer--center">
                <span>Bạn đã có tài khoản?</span>
                <Link to="/login">Đăng nhập ngay</Link>
            </div>
            <LegalAuthFooter />
        </div>
    );
};

export default FormRegister;
